import { Image24Regular, Person24Regular, HeartPulse24Regular } from '@fluentui/react-icons'
import { IconContainerOutline } from '@icons/IconContainerOutline'
import { IconDagsterOutline } from '@icons/IconDagsterOutline'
import { IconDatabricksOutline } from '@icons/IconDatabricksOutline'
import { IconLabsOutline } from '@icons/IconLabsOutline'
import { IconListViewOutline } from '@icons/IconListViewOutline'
import { IconTicketOutline } from '@icons/IconTicketOutline'
import { IconWarningOutline } from '@icons/IconWarningOutline'
import { IconServiceOutline } from '@icons/IconServiceOutline'
import { FlatSidebarMenu } from '@/components/ui/FlatSidebarMenu'
import { IconV2ColourSwatchOutline } from '@icons/IconV2ColourSwatchOutline'
import { SkillsIcon } from '@/const'

const navigation = () => [
  // { title: 'Details', Icon: AppGeneric24Regular, path: '.', visible: true },
  { title: 'Health Status', Icon: HeartPulse24Regular, path: 'health-status', visible: true },
  { title: 'Users', Icon: Person24Regular, path: 'users', visible: true },
  { title: 'Requests', Icon: IconTicketOutline, path: 'requests', visible: true },
  { title: 'Images', Icon: Image24Regular, path: 'images', visible: true },
  { title: 'Design System', Icon: IconV2ColourSwatchOutline, path: 'design-system', visible: true },
  { title: 'Containers', Icon: IconContainerOutline, path: 'containers', visible: true },
  { title: 'Databricks', Icon: IconDatabricksOutline, path: 'databricks', visible: true },
  { title: 'Dagster', Icon: IconDagsterOutline, path: 'dagster', visible: true },
  { title: 'Audit Logs', Icon: IconListViewOutline, path: 'audit-logs', visible: true },
  { title: 'Failed Logins', Icon: IconWarningOutline, path: 'failed-logins', visible: true },
  { title: 'LLM Providers', Icon: IconLabsOutline, path: 'llm-providers', visible: true },
  { title: 'Agent Tools', Icon: IconServiceOutline, path: 'agent-tools', visible: true },
  { title: 'Agent Skills', Icon: SkillsIcon, path: 'agent-skills', visible: true },
]

export function PlatformNavMenu({ sidebarOpen = true }: { sidebarOpen?: boolean }) {
  return <FlatSidebarMenu items={navigation()} sidebarOpen={sidebarOpen} />
}
